<template>
  <div>
    <el-button type="primary" @click="initAdd">添加</el-button>
    <el-table :data="regulations">
      <el-table-column prop="title" label="标题"></el-table-column>
      <!-- <el-table-column prop="content" label="内容"></el-table-column> -->
      <el-table-column
        prop="version"
        label="版本"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="update_note"
        label="更新内容"
        width="300"
      ></el-table-column>
      <el-table-column
        label="适用部门"
        width="180">
        <template slot-scope="scope">
          <el-tag
            v-for="dept in scope.row.applicable_department" 
            :key="dept"
            style="margin-right: 5px">
            {{ dept }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="适用对象"
        width="180">
        <template slot-scope="scope">
          <el-tag
            v-for="type in scope.row.applicable_type"
            :key="type"
            style="margin-right: 5px">
            {{ type }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)" size="medium" type="primary"
            >修改</el-button
          >
          <el-button
            @click="removeRegulation(scope.row._id.$id)"
            size="medium"
            type="primary"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="编辑" :visible.sync="show" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="标题">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="标题英文">
          <el-input v-model="form.title_en"></el-input>
        </el-form-item>
        
        <el-form-item label="适用对象">
          <el-checkbox-group v-model="form.applicable_type">
            <el-checkbox label="全职">全职</el-checkbox>
            <el-checkbox label="兼职">兼职</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
    
        <el-form-item label="适用部门">
          <el-select v-model="form.applicable_department" multiple>
            <el-option label="全部" value="全部"></el-option>
            <el-option label="研发部" value="研发部"></el-option>
            <el-option label="产品部" value="产品部"></el-option>
            <el-option label="市场部" value="市场部"></el-option>
            <el-option label="运营部" value="运营部"></el-option>
            <el-option label="人事部" value="人事部"></el-option>
            <el-option label="财务部" value="财务部"></el-option>
            
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <el-input type="textarea" :rows="5" v-model="form.content"></el-input>
        </el-form-item>
        <el-form-item label="内容英文">
          <el-input
            type="textarea"
            :rows="5"
            v-model="form.content_en"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本">
          <el-input v-model="form.version"></el-input>
        </el-form-item>
        <el-form-item label="版本更新内容">
          <el-input
            v-model="form.update_note"
            type="textarea"
            :rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本更新内容英文">
          <el-input
            v-model="form.update_note_en"
            type="textarea"
            :rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updateRegulation">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRegulations,
  updateRegulation,
  removeRegulation,
} from "../../api/assistant";
import { getUserId } from '../../utils/store.js'
export default {
  data() {
    return {
      regulations: [],
      id: "",
      show: false,
      form: {
        title: "",
        title_en: "",
        content: "",
        content_en: "",
        version: "",
        update_note: "",
        update_note_en: "",
        applicable_type: [],
        applicable_department: [],
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      getRegulations({
        account_id:getUserId()
      }).then((res) => {
        if (res.data.code === 0) {
          this.regulations = res.data.data;
        }
      });
    },
    initAdd() {
      this.show = true;
      this.id = "";
      this.form = {
        title: "",
        title_en: "",
        content: "",
        content_en: "",
        version: "",
        update_note: "",
        update_note_en: "",
        applicable_type: [],
        applicable_department: [],
      };
    },
    edit(row) {
      this.form = {
        ...row,
        applicable_type: row.applicable_type || [],
      };
      this.id = row._id.$id;
      this.show = true;
    },
    updateRegulation() {
      const formData = {
        ...this.form,
        applicable_type: this.form.applicable_type || [],
      };
      updateRegulation({
        id: this.id,
        title: formData.title,
        content: formData.content,
        version: formData.version,
        update_note: formData.update_note,
        title_en: formData.title_en,
        content_en: formData.content_en,
        update_note_en: formData.update_note_en,
        applicable_type: formData.applicable_type,
        applicable_department: formData.applicable_department,
        account_id:getUserId()
      }).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            message: "更新成功",
            type: "success",
          });
          this.fetchData();
        }
        this.show = false;
      });
    },
    removeRegulation(id) {
      removeRegulation(id).then((res) => {
        this.fetchData();
      });
    },
  },
};
</script>

<style>
</style>